export const generateId = () => {
    return Math.random().toString().substring(2);
};
